import { DateTimeService } from "src/app/core/utils/datetime.service";
import { Identidad } from "./identidad.model";
import { DatosBasicos } from "./datos-basicos.model";
import { InformacionLaboral } from "./info-laboral.model";
import { DatosContacto } from "./datos-contacto.model";
import { Empresa } from "./empresa.model";
import { Parentesco } from "./parentesco.model";
import { Complementos } from "./complementos.model";
import { agregarDocumentoRNEC, agregarDocumentosNoExigibles, mapearASolicitudDocumentos } from "./solicitud-documentos-mapper";
import { SolicitudTiposEnum } from './solicitud-tipos.enum';
import { ConyugeFormularioModel } from '../../../../components/cambio-estado-civil/exponer-informacion/conyuge-form';
import { TipoCECEnum } from '../../enum/TipoCECEnum';
import {CambioEstadoCivilEnum} from '../../../enums/cambio-estado-civil-enum';

export class ConyugeModel {
  public identidad = Identidad.instance();
  public motivo?: any;
  public datosBasicos = DatosBasicos.instance();
  public fechaExpedicion: string;
  public nacionalidad: string;
  public infoLaboral = InformacionLaboral.instance();
  public empresa = Empresa.instance();
  public datosContacto = DatosContacto.instance();
  public ocupacion: string;
  public cuidador: boolean;
  public parentesco = Parentesco.instance();
  public complementos: Complementos[] = [];

  static mapearDesdeFormularioAFT(solicitudTipo: SolicitudTiposEnum, conyugeForm: any) {
    const conyugeDto = ConyugeModel.instance();

    if (!conyugeForm)
      return conyugeDto;

    conyugeDto.identidad.tipo = conyugeForm["TipoIdConyuge"] || "";
    conyugeDto.identidad.numero = conyugeForm["NumIdConyuge"] || "";
    conyugeDto.ocupacion = conyugeForm["OcupacionConyuge"] || "";
    conyugeDto.cuidador = conyugeForm["CuidadorConyuge"] || false;
    conyugeDto.parentesco = { tipoParentesco: "CONYUGE", codigoParentesco: "SUB-0002" };
    conyugeDto.fechaExpedicion = conyugeForm["FechaExpedicionConyuge"] || "";
    conyugeDto.nacionalidad = conyugeForm["NacionalidadConyuge"] || null;

    conyugeDto.datosBasicos = {
      primerNombre: conyugeForm["Nombre1Conyuge"] || "",
      segundoNombre: conyugeForm["Nombre2Conyuge"] || "",
      primerApellido: conyugeForm["Apellido1Conyuge"] || "",
      segundoApellido: conyugeForm["Apellido2Conyuge"] || "",
      edad: DateTimeService.calcularEdad(conyugeForm["FechaNaciConyuge"]),
      genero: conyugeForm["GeneroConyuge"] || "",
      fechaNacimiento: conyugeForm["FechaNaciConyuge"] || "",
    }

    conyugeDto.infoLaboral.tipo = conyugeForm["TipoActividadConyuge"] || "";
    conyugeDto.infoLaboral.ingresos = {
      salario: {
        tipo: conyugeForm["TipoSalarioConyuge"] || "",
        basico: conyugeForm["SalarioConyuge"] || ""
      }
    }

    conyugeDto.infoLaboral.contrato = {
      tipo: conyugeForm["TipoContratoConyuge"] || "",
      horasDiaria: conyugeForm["HorasDiariaConyuge"] || "",
      horasMes: conyugeForm["HorasMesConyuge"] || "",
      fechaIngreso: conyugeForm["FechaIngresoConyuge"] || ""
    }

    conyugeDto.datosContacto = {
      correoElectronico: conyugeForm["CorreoElectronicoConyuge"] || "",
      celular: conyugeForm["CelularConyuge"] || "",
      telefono: conyugeForm["TelefonoConyuge"] || ""
    };

    conyugeDto.empresa.identidad = {
      tipo: conyugeForm["TipoIdEmpresaConyuge"] || "",
      numero: conyugeForm["NumIdEmpresaConyuge"] || ""
    };
    conyugeDto.empresa.razonSocial = conyugeForm["RazonEmpresaConyuge"] || "";
    conyugeDto.empresa.digitoVerificador = conyugeForm["DigVerEmpresaConyuge"] || "";
    conyugeDto.empresa.correoElectronico = "";


    let complementos: Array<any> = mapearASolicitudDocumentos(solicitudTipo, conyugeForm["documents"]);
    agregarDocumentoRNEC(solicitudTipo, conyugeForm["base64Valid"], complementos);
    agregarDocumentosNoExigibles(solicitudTipo, conyugeForm["documentsNoExigibles"], complementos);

    conyugeDto.complementos = complementos;
    return conyugeDto;
  }
  static mapearDesdeFormularioCEC(conyugeForm: ConyugeFormularioModel, docMapForm: any, cambioEstado?: any): ConyugeModel {
    const contratoApi = ConyugeModel.instance();
    contratoApi.identidad.tipo = conyugeForm["TipoIdConyuge"] || "";
    contratoApi.identidad.numero = conyugeForm["NumIdConyuge"] || "";
    contratoApi.ocupacion = conyugeForm["OcupacionConyuge"] || "";
    contratoApi.cuidador = conyugeForm["CuidadorConyuge"] || false;
    contratoApi.parentesco = { tipoParentesco: "CONYUGE", codigoParentesco: "SUB-0002" };
    contratoApi.fechaExpedicion = conyugeForm["FechaExpedicionConyuge"] || "";
    contratoApi.nacionalidad = conyugeForm["NacionalidadConyuge"] || null;
    contratoApi.datosBasicos = {
      primerNombre: conyugeForm["Nombre1Conyuge"] || "",
      segundoNombre: conyugeForm["Nombre2Conyuge"] || "",
      primerApellido: conyugeForm["Apellido1Conyuge"] || "",
      segundoApellido: conyugeForm["Apellido2Conyuge"] || "",
      edad: DateTimeService.calcularEdad(new Date(conyugeForm["FechaNaciConyuge"])),
      genero: conyugeForm["GeneroConyuge"] || "",
      fechaNacimiento: conyugeForm["FechaNaciConyuge"] || "",
    }
    contratoApi.infoLaboral.tipo = conyugeForm["OcupacionConyuge"] || "";
    contratoApi.infoLaboral = {
      tipo: conyugeForm.OcupacionConyuge || "",
      ingresos: {
        salario: {
          tipo: conyugeForm["TipoSalarioConyuge"] || "",
          basico: conyugeForm["SalarioConyuge"] || "",
        }
      },
      contrato: {
        tipo: "",
        horasDiaria: "",
        horasMes: "",
        fechaIngreso: ""
      }
    };
    contratoApi.nacionalidad = "";
    contratoApi.empresa = {
      identidad: {
        tipo: conyugeForm["TipoIdEmpresaConyuge"].toString() || "",
        numero: conyugeForm["NumIdEmpresaConyuge"].toString() || ""
      },
      digitoVerificador: conyugeForm["DigVerEmpresaConyuge"].toString() || "",
      razonSocial: conyugeForm["RazonEmpresaConyuge"] || "",
      correoElectronico: ""
    }
    let estadoCivil = parseInt(cambioEstado);
    contratoApi.motivo = estadoCivil?.toString();
    const solicitudTipo = ConyugeModel.calcularSolicitudTipoDesdeNuevoEstadoCivil(estadoCivil);
    let complementos: Array<any> = mapearASolicitudDocumentos(solicitudTipo, docMapForm["documents"]);
    agregarDocumentoRNEC(solicitudTipo, conyugeForm.base64Valid, complementos);
    agregarDocumentosNoExigibles(solicitudTipo, conyugeForm.documentsNoExigibles, complementos);
    contratoApi.complementos = complementos;
    return contratoApi;
  }

  static calcularSolicitudTipoDesdeNuevoEstadoCivil(nuevoEstadoCivil: CambioEstadoCivilEnum): SolicitudTiposEnum {
    let solicitudTipo;
    if (nuevoEstadoCivil === CambioEstadoCivilEnum.DE_SOLTERO_SEPARADO_O_VIUDO_A_UNION_LIBRE || nuevoEstadoCivil === CambioEstadoCivilEnum.DE_SOLTERO_SEPARADO_O_VIUDO_A_CASADO){
      solicitudTipo = SolicitudTiposEnum.AFB;
    } else if (nuevoEstadoCivil === CambioEstadoCivilEnum.DE_CASADO_O_UNION_LIBRE_A_VIUDO || nuevoEstadoCivil === CambioEstadoCivilEnum.DE_CASADO_O_UNION_LIBRE_A_SEPARADO){
      solicitudTipo = SolicitudTiposEnum.RIB;
    } else {
      solicitudTipo = SolicitudTiposEnum.CEC;
    }
    return solicitudTipo;
  }
  static instance() {
    return new this();
  }
}
